import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import {
  Button,
  FormControl,
  Input,
  Box,
  useToast,
  Text,
  Flex,
  Image,
} from "@chakra-ui/react";
import './App.css';

const UpdatePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const toast = useToast();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast({
        title: "Error",
        description: "Passwords do not match",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (newPassword.length < 6) {
      toast({
        title: "Error",
        description: "Password must be at least 6 characters",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reset-lost-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword }),
      });

      const data = await response.json();
      if (response.ok) {
        setIsSuccess(true);
        toast({
          title: "Password Updated",
          description: "Your password has been updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: data.error || "Failed to update password",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <Flex className="start-container" direction={{ base: 'column', md: 'row' }}>
        <Box flex="1.5" pr="5%">
          <Image src="/images/pablo_logo1.0.svg" alt="Logo" boxSize="48px" mb="5%" />
          <Text fontSize="9xl" fontWeight="Normal" mb={6}>
            Success!
          </Text>
          <Text fontSize="4xl" fontWeight="normal" mb="2%" lineHeight={1.1}>
            Your password has been updated successfully.
          </Text>
        </Box>

        <Box className="container-box" flex="1" mt={24}>
          <Text fontSize="lg" mb={6} color="gray.600">
            You can now log in with your new password.
          </Text>
          <Button 
            colorScheme="blue" 
            width="100%" 
            className="fed-button"
            onClick={() => navigate('/login')}
          >
            Go to Login
          </Button>
        </Box>
      </Flex>
    );
  }

  return (
    <Flex className="start-container" direction={{ base: 'column', md: 'row' }}>
      <Box flex="1.5" pr="5%">
        <Image src="/images/pablo_logo1.0.svg" alt="Logo" boxSize="48px" mb="5%" />
        <Text fontSize="9xl" fontWeight="Normal" mb={6}>
          New Password
        </Text>
        <Text fontSize="4xl" fontWeight="normal" mb="2%" lineHeight={1.1}>
          Create a new password for your account.
        </Text>
      </Box>

      <Box className="container-box" flex="1" mt={24}>
        <form onSubmit={handlePasswordUpdate} className="fed-form">
          <FormControl mb={4}>
            <Input
              placeholder="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="fed-input"
            />
          </FormControl>
          <FormControl mb={4}>
            <Input
              placeholder="Confirm New Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="fed-input"
            />
          </FormControl>
          <Button 
            colorScheme="blue" 
            type="submit" 
            width="100%" 
            className="fed-button"
            isLoading={isSubmitting}
            loadingText="Updating..."
          >
            Update Password
          </Button>
          <Flex mt={6}>
            <Text fontSize="sm" mr={4}>Remember your password?</Text>
            <Box>
              <Link to="/login" className="back-home-link">Back to Login</Link>
            </Box>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default UpdatePassword;
